import { hexToRgb, dangerColor } from 'assets/jss/material-dashboard-pro-react';

const fileUploadStyle = (theme) => ({
	sm: {
		height: '64px',
	},
	md: {
		height: '120px',
	},
	iconsm: {
		width: '24px !important',
	},
	iconmd: {},
	fileInputWrapper: {
		border: 'dotted 2px #979797',
		position: 'relative',
		'& > input': {
			position: 'absolute',
			left: 0,
			top: 0,
			width: '100%',
			height: '100%',
			opacity: 0,
			'&:hover:enabled': {
				'& + div': {
					backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.2)`,
					'& > p': {
						textDecoration: 'underline',
					},
				},
			},
			'&:disabled': {
				'&:hover': {
					cursor: 'not-allowed',
				},
				'& + div > p, & + div > svg': {
					opacity: '0.5 !important',
				},
			},
		},
	},
	fileInputContent: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		justifyContent: 'center',
		[theme.breakpoints.up('xs')]: {
			padding: '0 24px',
		},
		[theme.breakpoints.up('sm')]: {
			padding: '0 36px',
		},
		[theme.breakpoints.up('md')]: {
			padding: '0 24px',
		},
		width: '100%',
		height: '100%',
		transition: 'all .1s ease-in-out',
		'& svg': {
			width: '32px',
			height: '32px',
			color: '#979797',
			[theme.breakpoints.down('xs')]: {
				marginBottom: 0,
			},
		},
		'& p': {
			marginBottom: 0,
			textAlign: 'center',
		},
	},
	drag: {
		backgroundColor: `rgba(${hexToRgb(theme.palette.primary.main)}, 0.3)`,
	},
	iconRight: {
		[theme.breakpoints.up('sm')]: {
			position: 'absolute',
			right: 8,
		},
		[theme.breakpoints.up('md')]: {
			position: 'absolute',
			right: 24,
		},
	},
	loading: {
		height: '120px',
		display: 'flex',
		alignItems: 'center',
		'& > input': {
			display: 'none',
		},
	},
	loadingIndicatorWrapper: {
		width: '100%',
		'& > p': {
			marginTop: '16px',
			marginBottom: 0,
			textAlign: 'center',
		},
	},
	errorWrapper: {
		width: '100%',
		borderRadius: 8,
		border: `solid 1px ${dangerColor[0]}`,
		backgroundColor: `rgba(${hexToRgb(dangerColor[0])}, 0.06)`,
		padding: '18px 24px',
		fontSize: 12,
		maxWidth: '296px',
		margin: '0 auto 16px auto',
		textAlign: 'center',
	},
	uploadButton: {
		margin: 0,
		pointerEvents: 'none',
	},
	errorMessageWrapper: {
		paddingTop: 10,
	},
});

export default fileUploadStyle;
